import {
  CHECKBOX_CONTAINER_STYLES,
  CHECKBOX_STYLES,
  ERROR_MESSAGE_STYLES
} from '@/components/generic/Checkbox/checkbox-config';

type CheckboxProps = {
  label?: string;
  id: string;
  onChange: (id: string) => void;
  isChecked: boolean;
  isInvalid?: boolean;
  errorMessage?: string;
  labelClasses?: string;
  classes?: string;
};

export const Checkbox = ({
  label,
  id,
  onChange,
  isChecked,
  isInvalid,
  errorMessage,
  labelClasses,
  classes = 'h-4 w-4'
}: CheckboxProps) => (
  <div className={CHECKBOX_CONTAINER_STYLES}>
    <input
      type='checkbox'
      name={id}
      onChange={() => onChange(id)}
      checked={isChecked}
      className={`${CHECKBOX_STYLES} ${classes}`}
    />
    {label && (
      <label
        htmlFor={id}
        className={`${CHECKBOX_STYLES} ${labelClasses}`}
        onClick={() => onChange(id)}>
        {label}
      </label>
    )}
    {isInvalid && errorMessage && <p className={ERROR_MESSAGE_STYLES}>{errorMessage}</p>}
  </div>
);
